module.exports = {
    ACUITY_DATE_TIME_FORMAT: 'YYYY-MM-DDThh:mm:ssZ',
    DEFAULT_TIME_ZONE: 'America/Vancouver',
    DEFAULT_DATE_TIME_DISPLAY_FORMAT: 'YYYY-MM-DD hh:mm a',
    PRETTY_DATE_TIME_DISPLAY_FORMAT: 'MMMM Do YYYY, h:mm a'
};


/** WEBPACK FOOTER **
 ** ./assets/js/constants.js
 **/